import { render } from "./Personal.vue?vue&type=template&id=509ddfd0&scoped=true&ts=true"
import script from "./Personal.vue?vue&type=script&lang=ts"
export * from "./Personal.vue?vue&type=script&lang=ts"

import "./Personal.vue?vue&type=style&index=0&id=509ddfd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509ddfd0"]])

export default __exports__